import { render } from "./productosDetalle.vue?vue&type=template&id=67d1b1bb&scoped=true"
import script from "./productosDetalle.vue?vue&type=script&lang=js"
export * from "./productosDetalle.vue?vue&type=script&lang=js"

import "./productosDetalle.vue?vue&type=style&index=0&id=67d1b1bb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67d1b1bb"]])

export default __exports__